<template>
  <div>
    <b-card border-variant="light" class="custom-card">
      <b-form id="alter-form" class="alter-form">
        <b-form-row>
          <b-col> NOME DO COMUNICADO </b-col>
          <b-col>
            <b-form-input
              :class="disableFiled('name') ? 'isDisabled' : ''"
              ref="name"
              v-model.lazy.trim="form.name"
              :state="validateField('name')"
              placeholder="Informe o nome do comunicado"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> DATA INÍCIO </b-col>
          <b-col>
            <date-picker
              :disabled="disableFiled('dateStart')"
              datePickerId="dateStart"
              :key="getKeyDate(form.dateStart)"
              :dataValue="form.dateStart"
              :state="isValideStartDate"
              @datePickerChangedValue="onChangedDateStart"
            />
          </b-col>
          <div
            class="invalid text-invalid-right"
            v-show="isValideStartDate == false && (isToClone || !form.id)"
          >
            {{ startDateErrorMsg }}
          </div>
        </b-form-row>
        <b-form-row>
          <b-col> DATA FIM </b-col>
          <b-col>
            <date-picker
              :disabled="disableFiled('dateEnd')"
              datePickerId="dateEnd"
              :key="getKeyDate(form.dateEnd)"
              :state="validateFieldEndDate('dateEnd', 'dateStart', false)"
              :dataValue="form.dateEnd"
              @datePickerChangedValue="onChangedDateEnd"
            />
          </b-col>
          <div
            class="invalid text-invalid-right"
            v-show="
              validateFieldEndDate('dateEnd', 'dateStart', false) == false
            "
          >
            {{ endDateErrorMsg }}
          </div>
        </b-form-row>
        <b-form-row>
          <b-col> FREQUÊNCIA DE ENVIO </b-col>
          <b-col>
            <b-form-select
              :disabled="disableFiled('shippingFrequency')"
              v-model.lazy.trim="form.shippingFrequency"
              :state="validateField('shippingFrequency')"
              :options="shippingFrequencyOptions"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> DISPONIBILIZAR PARA TODOS OS COOPERADOS </b-col>
          <b-col class="custom-align">
            <b-form-checkbox
              class="ml-auto align-right-all-time"
              :disabled="disableFiled('allRecipient')"
              switch
              v-model="form.allRecipient"
              @change="this.onChangedAllRecipient"
            >
              {{ form.allRecipient ? "Sim" : "Não" }}
            </b-form-checkbox>
          </b-col>
        </b-form-row>
        <b-form-row v-if="!form.allRecipient">
          <b-col> CRM(S) </b-col>
          <b-col class="custom-align">
            <MultiSelectCrm
              :disabled="disableFiled('crms')"
              @onSelectCrm="onSelectCrm"
              :crms="form.crms"
            />
          </b-col>
        </b-form-row>
        <b-form-row v-if="!form.allRecipient">
          <b-col> ESPECIALIDADE(S) </b-col>
          <b-col class="custom-align">
            <b-form-tags
              :class="disableFiled('specialties') ? 'isDisabled' : ''"
              input-id="tags-pills"
              v-model="form.specialties"
              add-on-change
              no-outer-focus
            >
              <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                <ul
                  v-if="tags.length > 0"
                  class="list-inline d-inline-block mb-2"
                >
                  <li v-for="tag in tags" :key="tag" class="list-inline-item">
                    <b-form-tag
                      @remove="removeTag(tag)"
                      :title="tag"
                      :class="disableFiled('specialties') ? 'isDisabled' : ''"
                      variant="info"
                      >{{ tag }}</b-form-tag
                    >
                  </li>
                </ul>
                <b-form-select
                  :class="disableFiled('specialties') ? 'isDisabled' : ''"
                  v-bind="inputAttrs"
                  v-on="inputHandlers"
                  :disabled="specialtiesOptions.length === 0"
                  :options="specialtiesOptions"
                >
                  <template #first>
                    <!-- This is required to prevent bugs with Safari -->
                    <option disabled value="">
                      Selecione a(s) especialidade(s)
                    </option>
                  </template>
                </b-form-select>
              </template>
            </b-form-tags>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> MENSAGEM DE SAUDAÇÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableFiled('title') ? 'isDisabled' : ''"
              ref="title"
              v-model.lazy.trim="form.title"
              :state="validateField('title')"
              placeholder="Informe a mensagem de saudação."
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="text-size-mobile" ref="descriptionText"> TEXTO </b-col>
          <b-col class="h-100">
            <b-form-textarea
              id="textarea-1"
              :class="disableFiled('description') ? 'isDisabled' : ''"
              v-model="form.description"
              class="custom-textarea"
              :state="validateField('description')"
              placeholder="Informe o texto…"
              rows="5"
            ></b-form-textarea>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> TEXTO BOTÃO COMFIRMAÇÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableFiled('textButton') ? 'isDisabled' : ''"
              ref="textButton"
              v-model.lazy.trim="form.textButton"
              :state="validateField('textButton')"
              placeholder="Informe o texto “Ex: Está tudo certo!”"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> TEXTO BOTÃO DO LINK </b-col>
          <b-col>
            <b-form-input
              :class="disableFiled('textLink') ? 'isDisabled' : ''"
              ref="textLink"
              v-model.lazy.trim="form.textLink"
              placeholder="Informe o texto"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> LINK DO BOTÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableFiled('linkToRedirect') ? 'isDisabled' : ''"
              ref="linkToRedirect"
              v-model.lazy.trim="form.linkToRedirect"
              placeholder=""
            />
          </b-col>
        </b-form-row>

        <b-form-row v-if="!disableFiled('uploadFile')">
          <b-col class="">
            <upload-file
              @updateFile="eventToUpdateFile"
              :multiple="false"
              :description="'Anexar imagem'"
              :msgErro="'É necessário inserir o arquivo.'"
              accept="image/png,image/jpeg"
              :required="false"
              ref="upload"
              v-model.lazy.trim="form.files"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
    <b-row
      class="my-5 d-flex content-between justify-content-between custom-buttons"
    >
      <div>
        <b-button
          variant="outline-primary"
          :disabled="this.loading"
          @click="this.onCancel"
          class="ml-4"
        >
          Cancelar
        </b-button>

        <b-button
          form="alter-form"
          type="button"
          class="ml-4"
          variant="primary"
          id="submitButtonText"
          :disabled="this.loading"
          @click="() => this.onSubmitHandler(false)"
        >
          {{ this.getButtonLabel() }}
        </b-button>
      </div>
    </b-row>
    <report-success-modal
      ref="success-modal"
      description="O comunicado foi salvo com sucesso."
      :onAction="this.onActionConfirm"
      cancelButtonText="Ok, entendi!"
    />
  </div>
</template>
<script>
import ReportSuccessModal from "../../../components/base-modals/ReportSuccessModal.vue";
import UploadFile from "../../../components/upload-file/UploadFile.vue";
import MultiSelectCrm from "../../../components/multiselect-crm/MultiSelectCrm.vue";
import DatePicker from "../../../components/date-picker/DatePicker.vue";
import {
  createCommunication,
  getCommunicationById,
  updateCommunicationById,
} from "../../../services/communication/communication";
import { inject } from "@vue/composition-api";
import {
  validateField,
  validateFieldEndDate,
  validateFieldStartDate,
  validateFieldStartDateOnChange,
  requiredFieldsFilled,
} from "../../../utils/validate/validate.js";
import { createToast } from "../../../components/toast/toast";
import { getSpecialties } from "../../../services/training/trainingManagementService";
import RoutesPaths from "../../../router/router-structure/routes-paths";

const DefaultForm = {
  id: null,
  name: null,
  dateStart: null,
  dateEnd: null,
  allRecipient: false,
  crms: [],
  specialties: [],
  title: null,
  description: null,
  textButton: null,
  textLink: null,
  linkToRedirect: null,
  shippingFrequency: null,
  files: [],
  apresentationSequence: 0,
};

const ShippingFrequency = [
  { value: null, text: "Selecione a frequência", disabled: true },
  { value: "NOT_REPEATED", text: "Não repete" },
  { value: "WEEKLY", text: "Semanal" },
  { value: "MONTHLY", text: "Mensal" },
  { value: "SEMIANNUALLY", text: "Semestral" },
  { value: "ANNUAL", text: "Anual" },
];

export default {
  name: "communicatiom-manegement-form-view",
  props: ["onChangeTab", "index"],
  components: {
    DatePicker,
    MultiSelectCrm,
    UploadFile,
    ReportSuccessModal,
  },
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  async mounted() {
    this.isToClone = this.$route.query.toClone == "true";
    this.form = { ...DefaultForm };
    this.globalLoading = true;
    try {
      this.specialtiesOptions = this.availableOptions(await getSpecialties());
      if (this.$route.params.id) {
        this.communication = await getCommunicationById(this.$route.params.id);
        if (this.communication.linkImage) {
          const response = await fetch(this.getLink(this.communication));
          const { filename, mimeType } = await this.getFilename(response.url);
          const blob = await response.blob();
          const file = new File([blob], filename, { type: mimeType });
          this.form = {
            ...this.form,
            files: [file],
          };
          if (this.communication.action.canUpdateAll) {
            this.$refs.upload.files = [file];
          }
        }
        this.buildCommunication();
      }
      this.globalLoading = false;
    } catch (error) {
      this.globalLoading = false;
      console.error("mounted", error);
      createToast("Atenção", "Ocorreu um erro carregar as informações.");
    }
  },
  data() {
    return {
      form: { ...DefaultForm },
      formSubmited: false,
      communication: { action: { canUpdateAll: true } },
      validations: {},
      shippingFrequencyOptions: ShippingFrequency,
      specialtiesOptions: [],
      loading: false,
      validateField,
      validateFieldStartDate,
      validateFieldStartDateOnChange,
      isValideStartDate: null,
      validateFieldEndDate,
      requiredFieldsFilled,
      endDateErrorMsg: "",
      startDateErrorMsg: "",
      isToClone: false,
    };
  },
  methods: {
    disableFiled(fieldName) {
      if (this.isToClone) {
        return false;
      }
      if (fieldName == "dateEnd" || fieldName == "shippingFrequency") {
        return false;
      }
      return !this.communication?.action?.canUpdateAll;
    },
    getButtonLabel() {
      const id = !!this.$route.params.id;
      if (this.isToClone) {
        return "Clonar comunicado";
      } else if (id) {
        return "Atualizar comunicado";
      }
      return "Criar comunicado";
    },
    async getFilename(url) {
      const mimeTypes = {
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
      };
      const decodedUrl = decodeURIComponent(url);
      const filename = decodedUrl.split("/").pop().split("?")[0];
      const ext = filename.split(".").pop().toLowerCase();
      const mimeType = mimeTypes[ext] || "application/octet-stream"; // Padrão para tipos desconhecidos

      return { filename, mimeType };
    },
    getLink({ linkImage }) {
      if (this.$store.getters.isApp) {
        return linkImage.replace("https", "http");
      } else {
        return linkImage;
      }
    },
    eventToUpdateFile(files) {
      this.form.files = files;
    },
    onSelectCrm(crms) {
      this.form.crms = crms;
    },
    onChangedDateStart(value) {
      this.form.dateStart = value;
      //Futuro somente para cadastro e clonagem
      const onlyFuture = this.isToClone || !this.form.id;
      this.isValideStartDate = this.validateFieldStartDateOnChange(
        "dateStart",
        onlyFuture
      );
      if (this.isValideStartDate) {
        this.validateFieldEndDate("dateEnd", "dateStart", false);
      }
    },
    onChangedDateEnd(value) {
      this.form.dateEnd = value;
    },
    buildCommunication() {
      this.form.id = this.communication.id;
      this.form.name = this.communication.name;
      this.form.dateStart = this.communication.dateStart;
      this.form.dateEnd = this.communication.dateEnd;
      this.form.shippingFrequency = this.communication.shippingFrequency;
      this.form.textButton = this.communication.textButton;
      this.form.textLink = this.communication.textLink;
      this.form.linkToRedirect = this.communication.linkToRedirect;
      this.form.allRecipient = this.communication.allRecipient;
      this.form.description = this.communication.description;
      this.form.title = this.communication.title;
      this.form.crms = this.communication.crms;
      this.form.specialties = this.communication.specialties;
    },
    getKeyDate(date) {
      return date?.toString();
    },
    onChangedAllRecipient() {
      this.form = { allRecipient: !this.form.allRecipient, ...this.form };
    },
    availableOptions(specialties) {
      return [
        ...specialties
          .filter((opt) => this.form.specialties.indexOf(opt) === -1)
          .map((sp) => ({
            value: sp.description,
            text: sp.description,
          })),
      ];
    },
    async onSubmitHandler() {
      this.formSubmited = true;
      if (this.requiredFieldsFilled()) {
        this.loading = true;

        try {
          const id = !!this.$route.params.id;
          if (id && !this.isToClone) {
            await updateCommunicationById({ ...this.form });
          } else {
            await createCommunication({ ...this.form });
          }

          const modal = this.$refs["success-modal"].$children[0];
          modal.show();
        } catch (error) {
          this.loading = false;
          if (error.response.data.error_code === "COMMUNICATION_NOT_UPDATE") {
            const delay = 120000000;
            createToast(
              "Informação",
              error.response.data.message,
              "info",
              delay
            );
          } else {
            console.error("onSubmit", error);
            createToast(
              "Atenção",
              "Ocorreu um erro ao salvar informações do comunicado."
            );
          }
        }

        this.loading = false;
      }
    },
    onActionConfirm() {
      this.onCancel();
    },
    onCancel() {
      this.$router.push(RoutesPaths.communicationManagement.rootName());
    },
  },
};
</script>

<style lang="scss" scoped>
.align-right-all-time {
  position: absolute;
  right: 4px;
}
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.b-form-tag > button.b-form-tag-remove {
  font-size: 180%;
}
.text-invalid-right {
  width: 100%;
  text-align: right;
}
.custom-align {
  margin-right: 1rem;
}
.custom-textarea {
  color: var(--dark-0) !important;
  font-size: 1.4rem !important;
}
.isDisabled {
  pointer-events: none;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.6;
}
</style>
